const DynamicPostRequest = (() => {
    const DOM = {};
    let previousArchiveLoaded = '';
    let previousArchiveDate = '';
    let observerTarget;
    let targetClicked = false;

    const cacheDOM = () => {
        DOM.categoriesParent = document.getElementsByClassName("js-categories")[0];
        DOM.categories = document.querySelectorAll(".js-categories > li");
        DOM.loadMore   = document.getElementById("js-load-more");
        DOM.parentEl   = document.getElementsByClassName("js-categories-wrapper")[0];
        DOM.parentSection = document.getElementsByClassName("js-categories-section")[0];
        DOM.loadMoreBlogArchive = document.getElementsByClassName("js-load-blog-archive-post");
    }

    const removeLoader = () => {
        setTimeout(() => {
            const loader = document.querySelector(".loading, .loading-circle");
            if (loader) loader.remove();
            if (DOM.loadMore) DOM.loadMore.innerHTML = `Load More`;
            DOM.parentSection.classList.remove('js-loading');
        }, 500);
    }

    const updatePosts = (postData, postType) => {
        let content = '';

        if (postType === 'post') {
            const postTitle = postData.title;
            const postDescription = postData.excerpt;
            const postThumbnail = postData.thumbnail;
            const postURL = postData.url;
            const postCategories = postData.taxonomy;
            const postPrimaryCategory = postData.primaryTaxonomy;
            const postDate = postData.date;

            let postCategory = '';
            if (postPrimaryCategory) {
                postCategory = `<li>${postPrimaryCategory}</li>`;
            } else {
                Array.from(postCategories).forEach(category => {
                    postCategory += `<li>${category}</li>`;
                });
            }

            content = `<div class="content__post__item content__post__item--blog">
                            <div class="content__post__item__wrapper">
                                <a href="${postURL}">
                                    <div class="content__post__image content__post__image--alt">
                                        ${postThumbnail}
                                    </div>
                                    <div class="content__post__item__text">
                                        <ul>
                                            ${postCategory}
                                            <li>${postDate}</li>
                                        </ul>
                                        <h3>${postTitle}</h3>
                                        <p>${postDescription}</p>
                                    </div>
                                </a>
                            </div>
                        </div>`;
        } else if (postType === 'team') {
            // Team post structure (kept as before)
            const postTitle = postData.title;
            const postThumbnail = postData.thumbnail;
            const postThumbnailAlt = postData.thumbnail_alt;
            const postJobTitle = postData.job_title ? `<span>${postData.job_title}</span>` : '';
            const postContactDetails = postData.contact_details;
            const postSocialDetails = postData.social_details;

            let contactDetails = '';
            if (postContactDetails) {
                contactDetails += `<ul>`;
                Array.from(postContactDetails).forEach(contact => {
                    const telephone_label = contact.telephone_label ? `<span>${contact.telephone_label} :</span>` : '';
                    const telephone_number = contact.telephone_number ?? '';
                    const telephone_add_extension = contact.telephone_add_extension ?? '';
                    const telephone_extension = contact.telephone_extension ?? '';
                    const telephone_ext_text = telephone_add_extension ? `<span>Ext : ${telephone_extension}</span>` : '';

                    contactDetails += `<li>${telephone_label}<a href="tel:${telephone_number}" class="team__item__email button-arrow">${telephone_number}</a>${telephone_ext_text}</li>`;
                });
                contactDetails += `</ul>`;
            }

            let socialDetails = '';
            if (postSocialDetails) {
                socialDetails += `<div class="team__item__contacts team__item__contacts--column"><ul class="team__item__social">`;
                Array.from(postSocialDetails).forEach(social => {
                    const social_label = social.social_label ?? '';
                    const social_url = social.social_url ?? '';
                    socialDetails += `<li class="${social_label}"><a href="${social_url}" target="_blank" rel="noopener noreferrer" title="${social_label}"><span class="sr-only">${social_label}</span></a></li>`;
                });
                socialDetails += `</ul></div>`;
            }

            content = `<div class="team__item">
                            <img src="${postThumbnail}" alt="${postThumbnailAlt}">
                            <div class="team__item__inner">
                                <div class="team__item__details">
                                    <h3>${postTitle}</h3>
                                    ${postJobTitle}
                                    ${contactDetails}
                                </div>
                                ${socialDetails}
                            </div>
                        </div>`;
        } else {
            // Listing grid
            const postTitle = postData.title;
            const postDescription = postData.excerpt;
            const postThumbnail = postData.thumbnail;
            const postURL = postData.url;
            const postCategories = postData.taxonomy;

            let postCategory = '';
            Array.from(postCategories).forEach(category => {
                postCategory += `<li>${category}</li>`;
            });

            content = `<div class="listing-grid__item">
                        <a href="${postURL}" title="${postTitle}">
                            <div class="listing-grid__image">${postThumbnail}</div>
                        </a>
                        <div class="listing-grid__details">
                            <ul>${postCategory}</ul>
                            <h3><a href="${postURL}">${postTitle}</a></h3>
                            <p>${postDescription}</p>
                        </div>
                    </div>`;
        }

        return content;
    }

    const showAllPosts = (postsData, postType, nextPage, postID) => {
        const loadMoreBtn = DOM.loadMore;

        // Current and total pages from REST response
        const currentPage = parseInt(nextPage) || 1;
        const { paged, max_num_pages } = postsData.pagination || {};

        // Only clear posts on first page load (page 1)
        if (!postID && currentPage === 1) {
            const oldPosts = DOM.parentEl.querySelectorAll(".listing-grid__item");
            oldPosts.forEach(oldPost => oldPost.remove());
        }

        // Build HTML content
        let content = '';
        postsData.postDetails.forEach(post => {
            content += updatePosts(post, postType);
        });

        // Append new posts instead of replacing
        if (currentPage > 1) {
            DOM.loadMore.insertAdjacentHTML('beforebegin', content);
        } else {
            DOM.parentEl.innerHTML = content;
        }

        // Pagination control
        if (loadMoreBtn) {
            const nextPageNumber = (paged || currentPage) + 1;

            loadMoreBtn.dataset.loadNext = nextPageNumber;
            loadMoreBtn.setAttribute('data-load-next', nextPageNumber);

            // Hide button if we've reached the last page
            if (paged >= max_num_pages) {
                loadMoreBtn.style.display = 'none';
                lazyLoadObserver.unobserve(loadMoreBtn);
            } else {
                loadMoreBtn.style.display = 'block';
            }
        }

        removeLoader();

    };



    const setFilterActive = (target) => {
        const element = target.currentTarget;
        element.classList.add('active');
    }

    const removeActiveState = () => {
        Array.from(DOM.categories).forEach(category => category.classList.remove('active'));
    }

    const getCategoryDetails = (el, elementClicked = false) => {
        let targetElement;

        if (elementClicked) {
            el.preventDefault();
            el.stopPropagation();
            removeActiveState();
            setFilterActive(el);
            targetClicked = true;
            targetElement = el.currentTarget;
        } else {
            targetElement = el.target; // triggered by observer
        }

        if (!targetElement) return;

        const postID = targetElement.getAttribute('data-id');
        const postType = DOM.categoriesParent.getAttribute("data-post-type");
        const postPerPage = targetElement.getAttribute('data-post-per-page') ?? 6;
        const postPaged = targetElement.getAttribute('data-load-next') ?? 1;

        const categoryPostsDataURL = !postID
            ? `${document.location.origin}/wp-json/v2/taxonomy/all/?post_type=${postType}&posts_per_page=${postPerPage}&paged=${postPaged}`
            : `${document.location.origin}/wp-json/v2/taxonomy/?post_type=${postType}&taxonomy_id=${postID}&posts_per_page=${postPerPage}&paged=${postPaged}`;

        if (elementClicked) {
            const loader = `<div class="loading-circle"><div class="loading-circle__eclipse"><div></div></div></div>`;
            DOM.parentSection.insertAdjacentHTML('beforeend', loader);
        } else {
            const loader = `<div class="loading"><div></div><div></div><div></div><div></div></div>`;
            DOM.loadMore.innerHTML = loader;
        }

        DOM.parentSection.classList.add('js-loading');

        const postsRequest = new XMLHttpRequest();
        postsRequest.open("GET", categoryPostsDataURL);
        postsRequest.send();
        postsRequest.onload = () => {
            if (postsRequest.status === 200) {
                const postsData = JSON.parse(postsRequest.response);
                showAllPosts(postsData, postType, postPaged, postID);
            }
        };
    };


    const lazyLoadObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                getCategoryDetails(entry);
                observerTarget = entry.target;
            }
        });
    });

    const eventListener = () => {
        // Category buttons
        if (DOM.categories) {
            Array.from(DOM.categories).forEach(category => {
                category.addEventListener("click", (event) => getCategoryDetails(event, true));
            });
        }

        // Load more button click
        if (DOM.loadMore) {
            DOM.loadMore.addEventListener("click", (event) => getCategoryDetails(event, true));
            lazyLoadObserver.observe(DOM.loadMore); // also triggers on scroll into view
        }

        // Blog archive load more (if present)
        if (DOM.loadMoreBlogArchive) {
            Array.from(DOM.loadMoreBlogArchive).forEach(button => {
                button.addEventListener("click", (event) => getCategoryDetails(event, true));
            });
        }
    };


    const init = () => {
        cacheDOM();
        eventListener();
    }

    return {
        init
    }

})();

export default DynamicPostRequest;
